import React from "react";
import { MdCheckCircle } from "react-icons/md";

function ThankYou() {
    return (
        <div className="h-[80vh] flex flex-col items-center justify-center gap-10">
            <MdCheckCircle className="text-6xl text-green-500" />
            <h1 className="text-3xl font-bold text-center">
                Thank you for your submission!
            </h1>
            <p>
                Abbiamo salvato la tua risposta e ti abbiamo inviato una copia via email.
                <br />
                Verrai aggiornato nei prossimi giorni riguardo i corsi che hai selezionato.
            </p>
        </div>
    );
}

export default ThankYou;